import { getMainApi, postMainApi, putMainApi, deleteMainApi } from "@Shared/utils/ajax";
export const getUserTemplate = templateId => {
  const endpoint = `/remarketing/template/${templateId}`;
  return getMainApi({}, endpoint);
};
export const updateTemplate = (templateId, data) => {
  const endpoint = `/remarketing/template/${templateId}`;
  return putMainApi(data, endpoint);
};
export const createTemplate = data => {
  const endpoint = "/remarketing/template";
  return postMainApi(data, endpoint);
};
export const sendTestEmail = (templateId, data) => {
  const endpoint = `/remarketing/template/${templateId}/send-test`;
  return postMainApi(data, endpoint);
};
export const getTemplates = () => {
  return getMainApi({}, "/remarketing/template");
};
export const deleteTemplate = templateId => {
  const endpoint = `/remarketing/template/${templateId}`;
  return deleteMainApi(endpoint);
};
export const getBeePluginToken = async () => {
  return getMainApi({}, "/remarketing/token");
};
export const getTemplateFromUrl = async url => {
  return $.get(url);
};